import { createSlice } from "@reduxjs/toolkit";

interface utilsState {
  rateNotifierTimer: Date | null;
}

const initialState: utilsState = { rateNotifierTimer: null };

export const utilsSlice = createSlice({
  name: "utils",
  initialState,
  reducers: {
    setRateNotifier: (state, action) => {
      state.rateNotifierTimer = JSON.parse(action.payload);
    },
  },
});

export const { setRateNotifier } = utilsSlice.actions;

export default utilsSlice.reducer;
